import { LogErrors } from './../../LogErrors'

import { DoubleAttempt } from './../Helpers/DoubleAttempt'


const GetZtudents = async (idCenter, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/GetAllZtudentsByInstructor"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetZtudents - DL Ztudents', error)
        return { success: false, message: `No ha sido posible obtener el listado de Ztudiantes. Intenta actualizar la página o intenta actualizarla más tarde.` }
    }
}

const HideToZtudent = async (idZtudiante, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idCenter: idCenter
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/HideZtudianteFromAllGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('HideToZtudent - DL Ztudents', error)
        return { success: false, message: `No ha sido posible ocultar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

const ShowToZtudent = async (idZtudiante, idCenter, token) => {
    try {
        const dataToSend = {
            idZtudiante: idZtudiante,
            idCenter: idCenter
        }

        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }
        
        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ShowZtudianteFromAllGroups"

        const response = await DoubleAttempt(url, parameters)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ShowToZtudent - DL Ztudents', error)
        return { success: false, message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

const ResetZtudiantePassword = async (idCenter, idZtudiante, username, token) => {
    try {
        const dataToSend = {
            idCenter: idCenter,
            idZtudiante: idZtudiante,
            username: username
        }
        
        const parameters = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(dataToSend)
        }

        const url = process.env.REACT_APP_API_URL + "/api/V2/Api/ResetZtudiantePassword"

        const response = await DoubleAttempt(url, parameters, false)

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('ResetZtudiantePassword - DL Ztudents', error)
        return { success: false, message: `No ha sido posible mostrar al Ztudiante. Inténtalo nuevamente o más tarde.` }
    }
}

export { GetZtudents, HideToZtudent, ShowToZtudent, ResetZtudiantePassword };